import React, {useState} from 'react';
import Select from 'react-select';
import NewReleasesIcon from '@mui/icons-material/NewReleases';

const customStyles = {
  control: base => ({
    ...base,
    background: '#4b4b4b',
    borderRadius: '5px',
    fontSize: '14px',
    border: '1px solid #ffffff',
    marginBottom: '5px',
    marginTop: '10px',
    width: '250px'
  }),
  singleValue: base => ({
    ...base,
    color: '#ffffff', 
    
  }),
  input: base => ({
    ...base,
    color: '#ffffff', 
  }),
  menu: base => ({
    ...base,
    background: '#4b4b4b',
    color: '#ececec', 
    fontSize: '14px',
    width: '250px'
  }),
  option: (base, { isFocused }) => ({
    ...base,
    backgroundColor: isFocused ? '#bdbdbd' : 'transparent', 
    color: isFocused ? '#000000' : '#ececec', 
  }),
};

const FobContainerEdit = ({toggleVisibilityFob, isVisibleFob, fobData, handleChangeFob, selectedFob, commentFob, commentTextAreaRefFob,
      handleCommentChangeFob, toggleFobMarker, fobMarker, fobConstructSave, rankComponentData, handleChangeRankComponentFob, selectedRankFob,
      dividerData, selectedDividerOptionFob, handleChangeDividerSelectFob, boxData, selectedBox, handleChangeBox, polishingData, selectedPolishing, handleChangePolishing,
      handleAdapterChange, adapterCount, handlePigtailChange, pigtailCount}) => {

  const [showTooltip, setShowTooltip] = useState(false);

   const options = dividerData.map(divider => ({
        value: divider.id,  
        label: divider.model,
        group: divider.polishingId === 1 ? "UPC" : "APC", 
      }));
    
      // Группировка опций
      const groupedOptions = [
        {
          label: "UPC",
          options: options.filter(option => option.group === "UPC"),
        },
        {
          label: "APC",
          options: options.filter(option => option.group === "APC"),
        },
      ];


  return (
    <React.Fragment>
      <button onClick={toggleVisibilityFob} className={isVisibleFob ? 'buttonIsHideDrawer2' : 'buttonIsHideDrawer'} >
        {isVisibleFob ? 'Фоб: скрыть' : 'Фоб: показать'}
      </button>
      {isVisibleFob && (
        <div className='divСommunicationsDrawer'>
         {selectedRankFob === '1' || selectedRankFob === '2' ? (
           <img src='./fob.png' width='30' height='30' style={{ marginRight: "5px" }} />
            ) : (
            <img src='./fob_canton.png' width='30' height='30' style={{ marginRight: "5px" }} />
          )}
          <label className='textTitleDrawer'>Фоб</label>
          <hr className="horizontalLineDrawer" />
          <div>
            <select className="selectStyleDrawer" style={{ marginBottom: "5px", marginTop: "10px" }} onChange={handleChangeBox} value={selectedBox}>
              <option value="null">Выберите ящик</option>
              {boxData.map(box => (
                <option key={box.id} value={box.id}>{box.model}</option>
              ))}
            </select>
            <br/>
           <select className="selectStyleDrawer" style={{ marginBottom: "5px", marginTop: "10px" }} onChange={handleChangeFob} value={selectedFob}>
              <option value="null">Выберите фоб</option>
              {fobData.map(fob => (
                <option key={fob.id} value={fob.id}>{fob.name}</option>
              ))}
            </select>
            <br/>
             <Select
                className="selectSearchDrawer"
                options={groupedOptions}
                value={selectedDividerOptionFob} 
                styles={customStyles}
                onChange={handleChangeDividerSelectFob}
                placeholder={"Выберите делитель"}
                isClearable
              />

              <div className="divСommunicationsDrawer" style={{ border: '1px solid #d6b220'}}>
                 <select className="selectStyleDrawer" style={{ marginBottom: "5px", marginTop: "10px" }} onChange={handleChangePolishing} value={selectedPolishing}>
                  <option value="null">Выберите полировку</option>
                  {polishingData.map(polishing => (
                    <option key={polishing.id} value={polishing.id}>{polishing.type}</option>
                  ))}
                 </select>
                  <br/>
                  <>
                    <label className='textTitleDrawer'>Pigtail: </label>
                        
                    <input
                      type='number'
                      min={0}
                      className='textInput2EditingModal'
                      value={pigtailCount} 
                      onChange={handlePigtailChange} 
                    /> 
                    <label className='textTitleDrawer' style={{marginLeft: '5px', fontSize: '16px'}}>кол. </label> 
                    </>
                    <br/>
                  <>
                    <label className='textTitleDrawer'>Adapter: </label>
                        
                    <input
                      type='number'
                      min={0}
                      className='textInput2EditingModal'
                      value={adapterCount} 
                      onChange={handleAdapterChange} 
                    />  
                    <label className='textTitleDrawer' style={{marginLeft: '5px', fontSize: '16px'}}>кол. </label> 
                    </>
              </div>
          
            {/* <select className="selectStyleDrawer" style={{ marginTop: "10px"}} onChange={handleChangeRankComponentFob} value={selectedRankFob}>
              <option value="null">Относится к узлу</option>
              {rankComponentData.map(rank => (
                <option key={rank.id} value={rank.id}>{rank.name}</option>
              ))}
            </select>

            <div
                style={{
                  position: "relative",
                  display: "inline-block",
                }}
                onMouseEnter={() => setShowTooltip(true)}
                onMouseLeave={() => setShowTooltip(false)}
              >
                <NewReleasesIcon
                  style={{
                    cursor: "pointer",
                    color: "#ebb434",
                    fontSize: "24px",
                    marginLeft: "5px",
                  }}
                />
                {showTooltip && (
                  <div className='tooltipWarning' >
                    Выберите максимальный ранг линка,<br/>
                    который присутствует в фобе.
                  </div>
                )}
              </div> */}
     
            <hr className="horizontalLineDrawer" style={{ marginTop: "10px" }} />

          </div>
          <div >

            <textarea
              className='areaDescriptionDrawer'
              placeholder="Комментарий"
              rows={3}
              cols={44}
              value={commentFob}
              ref={commentTextAreaRefFob}
              onChange={handleCommentChangeFob}
            />
            <button onClick={toggleFobMarker} className={fobMarker ? 'buttonIsDrawingDrawer2' : 'buttonIsDrawingDrawer'}>
              {fobMarker ? 'Завершить' : 'Добавить'}
            </button>
            <button onClick={fobConstructSave} className='buttonSaveDrawer'>Сохранить</button>
          </div>
        </div>
      )}
    </React.Fragment>
  );
}

export default FobContainerEdit;